/**
 * CSV 取り込みのタグ列を解析する（プレビュー用）。
 * `functions/src/imports/tagParse.ts` と同じロジックに保つこと。
 *
 * - 1 セルに複数タグ。区切りは空白（全角含む）・カンマ・読点・セミコロン・改行
 * - 先頭の # / ＃ は有っても無くてもよい（内部保存は # なし。表示時に # を付ける）
 */

export const MAX_IMPORT_TAGS_PER_PAGE = 20;
export const MAX_IMPORT_TAG_LENGTH = 50;

const TAG_SEPARATOR = /[\s,、，;；\u3000]+/u;

export function parseImportTags(cell: string | null | undefined): string[] {
  if (!cell) return [];
  const tags: string[] = [];
  const seen = new Set<string>();

  for (const raw of String(cell).split(TAG_SEPARATOR)) {
    if (!raw) continue;
    const cleaned = raw
      .normalize('NFKC')
      .replace(/^#+/, '')
      .replace(/[^\p{L}\p{N}\p{M}_]/gu, '')
      .slice(0, MAX_IMPORT_TAG_LENGTH);
    if (!cleaned || seen.has(cleaned)) continue;
    seen.add(cleaned);
    tags.push(cleaned);
    if (tags.length >= MAX_IMPORT_TAGS_PER_PAGE) break;
  }
  return tags;
}
